import { debounce, put } from 'typed-redux-saga';
import { logError } from '../../../../../utils/log';
import { appNotification } from '../../../../containers/App/appNotification';
import { getApiPermittedAccountFreeList } from '../../../../services/account';
import { getApiErrorMessage } from '../../../../services/ApiClient';
import { newTransactionActions } from '../slice';

function* searchDebitAccount(action: ReturnType<typeof newTransactionActions.searchDebitAccount>) {
    try {
        const res = yield* getApiPermittedAccountFreeList(action.payload);
        yield* put(newTransactionActions.setDebitAccountList(res));
    }
    catch (error) {
        logError({
            error,
            target: 'AccountingNewTransactionPage.searchDebitAccount',
        });
        const message = getApiErrorMessage(error);
        yield* put(appNotification.unknownError(message));
    }
}

export function* searchDebitAccountSaga() {
    yield* debounce(
        500,
        newTransactionActions.searchDebitAccount,
        searchDebitAccount,
    );
}
